import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateQRCode, QRCode } from "../types";
import { get, post } from "../services/restClient";
import { Endpoint, setEndpoint } from "../services/endpoints";

const getQRCodes = async (inventoryId: string) => {
    const data = await get<QRCode>(setEndpoint(Endpoint.qrCodes, { inventoryId }), {
        requireAuth: true,
    });
    return data;
};

export const useGetQRCodesByInventory = (inventoryId: string) => {
    return useQuery({
        queryKey: ["qrcodes", inventoryId],
        queryFn: () => getQRCodes(inventoryId),
    });
};

const extractId = (url: string) => {
    const parts = url.split("/");
    return parts[parts.length - 1];
};

export const useGetQRCodeByUrl = (url: string) => {
    const isYllw = url.includes("inventory.yllw.com/qrCode");
    const isNumeric = !isNaN(Number(url));

    return useQuery({
        queryKey: ["qrcode", url],
        queryFn: async () => {
            const data = await get<QRCode>(
                setEndpoint(Endpoint.qrCodeByUrl, { url: extractId(url) }),
                { requireAuth: true },
            );
            return data;
        },
        enabled: !!url && isNumeric,
    });
};

export const useCreateQRCode = () => {
    const request = createQRCode;
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ qrCode }: { qrCode: CreateQRCode }) => {
            return request(qrCode);
        },
        onSuccess: (data, { qrCode }) => {
            void queryClient.invalidateQueries({
                queryKey: ["qrcodes", qrCode.inventoryId],
            });
            return data;
        },
    });
};

const createQRCode = async (qrCode: CreateQRCode) => {
    const data = await post<CreateQRCode, QRCode>(setEndpoint(Endpoint.qrCodePost), qrCode, {
        requireAuth: true,
    });
    return data;
};
